import { reject, equals } from 'ramda';

export const TOGGLE_SELECTED_FILTER = 'toggleSelectedFilter';
export const CLEAR_SELECTED_FILTERS = 'clearSelectedFilters';
export const SET_TOPICS = 'setTopics';
export const SET_SELECTED_TOPIC = 'setSelectedTopic';
export const SET_SELECTED_SUBTOPIC = 'setSelectedSubtopic';
export const SET_DATA = 'setData';
export const SET_YEAR_FILTER = 'setYearFilter';
export const SET_LOADING = 'setLoading';

const toggleSelectedFilter = (state, region) => {
  if (state.selectedFilters.includes(region)) {
    state.selectedFilters = reject(equals(region), state.selectedFilters);
  } else {
    state.selectedFilters.push(region);
  }
};

const clearSelectedFilters = (state) => {
  state.selectedFilters = [];
};

const setTopics = (state, topics) => {
  state.topics = topics;
};

const setSelectedTopic = (state, topic) => {
  state.selectedTopic = topic;
  state.data = [];
};

const setSelectedSubtopic = (state, subtopic) => {
  state.selectedFilters = [];
  state.selectedSubtopic = subtopic;
};

const setData = (state, data) => {
  state.data = Object.freeze(data);
};

const setYearFilter = (state, year) => {
  state.yearFilter = year;
};

const setLoading = (state, loading) => {
  state.loading = loading;
};

export default {
  [TOGGLE_SELECTED_FILTER]: toggleSelectedFilter,
  [CLEAR_SELECTED_FILTERS]: clearSelectedFilters,
  [SET_TOPICS]: setTopics,
  [SET_SELECTED_TOPIC]: setSelectedTopic,
  [SET_SELECTED_SUBTOPIC]: setSelectedSubtopic,
  [SET_DATA]: setData,
  [SET_YEAR_FILTER]: setYearFilter,
  [SET_LOADING]: setLoading,
};
